
export default function Testimonials() {
  const testimonials = [
    {
      name: 'Carlos Martínez',
      location: 'Castelldefels',
      rating: 5,
      text: 'Vendí mi coche averiado en menos de 2 horas. Me pagaron al instante y se encargaron de todo el papeleo. Servicio impecable en Castelldefels. Muy recomendable.',
      date: 'Hace 2 semanas'
    },
    {
      name: 'Laura Sánchez',
      location: 'Gavà',
      rating: 5,
      text: 'Tenía un coche accidentado que no sabía qué hacer con él. Me dieron un precio justo, lo recogieron gratis y tramitaron la baja. Excelente trato y muy profesionales.',
      date: 'Hace 1 mes'
    },
    {
      name: 'Miguel Rodríguez',
      location: 'Viladecans',
      rating: 5,
      text: 'Mejor precio que otros desguaces de la zona. Proceso rápido y transparente. Recogida gratuita en el mismo día. Muy contentos con el servicio.',
      date: 'Hace 3 semanas'
    },
    {
      name: 'Ana García',
      location: 'Castelldefels',
      rating: 5,
      text: 'Mi coche llevaba años sin ITV y no arrancaba. Me dieron una buena valoración y se lo llevaron sin problemas. Gestionaron toda la baja en DGT. Muy profesionales.',
      date: 'Hace 1 semana'
    },
    {
      name: 'Javier López',
      location: 'Sant Boi',
      rating: 5,
      text: 'Vendí mi furgoneta vieja. Valoración rápida, pago inmediato y recogida gratis. No tuve que hacer ningún papeleo. Servicio excelente, totalmente recomendable.',
      date: 'Hace 2 meses'
    },
    {
      name: 'Isabel Fernández',
      location: 'Castelldefels',
      rating: 5,
      text: 'Trato familiar y cercano. Me explicaron todo el proceso claramente. Precio justo por mi coche para desguace. Muy satisfecha con el servicio en Castelldefels.',
      date: 'Hace 3 semanas'
    }
  ];

  return (
    <section id="testimonios" className="py-12 sm:py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-orange-100 text-orange-700 rounded-full mb-3 sm:mb-4">
            <i className="ri-star-line text-base sm:text-lg"></i>
            <span className="text-xs sm:text-sm font-semibold whitespace-nowrap">OPINIONES</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
            Lo que Dicen Nuestros <strong>Clientes</strong>
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-2">
            Más de 5.000 clientes satisfechos que han vendido su coche en nuestro desguace
          </p>
          
          {/* Overall Rating */}
          <div className="flex items-center justify-center gap-3 sm:gap-4 mt-6 sm:mt-8">
            <div className="flex gap-0.5 sm:gap-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <i key={star} className="ri-star-fill text-xl sm:text-2xl lg:text-3xl text-amber-400"></i>
              ))}
            </div>
            <div className="text-left">
              <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900">4.9/5</div>
              <p className="text-xs sm:text-sm text-gray-600">Basado en 250+ opiniones</p>
            </div>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl sm:rounded-2xl p-5 sm:p-6 lg:p-8 hover:shadow-xl transition-all duration-300 flex flex-col"
            >
              {/* Rating Stars */}
              <div className="flex gap-0.5 sm:gap-1 mb-3 sm:mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-lg sm:text-xl text-amber-400"></i>
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-700 leading-relaxed mb-4 sm:mb-6 flex-grow text-sm sm:text-base">
                "{testimonial.text}"
              </p>

              {/* Author Info */}
              <div className="flex items-center justify-between pt-4 sm:pt-6 border-t border-gray-200">
                <div>
                  <p className="font-semibold text-gray-900 text-sm sm:text-base">{testimonial.name}</p>
                  <p className="text-xs sm:text-sm text-gray-600 flex items-center gap-1">
                    <i className="ri-map-pin-line text-teal-600"></i>
                    {testimonial.location}
                  </p>
                </div>
                <div className="text-xs text-gray-500">
                  {testimonial.date}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-10 sm:mt-16 text-center">
          <p className="text-gray-600 mb-4 sm:mb-6 text-sm sm:text-lg">¿Quieres vender tu coche como ellos?</p>
          <a
            href="#valoracion"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('valoracion')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-teal-600 text-white rounded-full font-bold text-sm sm:text-lg hover:bg-teal-700 transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-calculator-line text-xl sm:text-2xl"></i>
            Solicitar Valoración Gratis
          </a>
        </div>
      </div>
    </section>
  );
}
